import { render, staticRenderFns } from "./MemberFocuses.vue?vue&type=template&id=a475d5d2"
import script from "./MemberFocuses.vue?vue&type=script&lang=js"
export * from "./MemberFocuses.vue?vue&type=script&lang=js"
import style0 from "./MemberFocuses.vue?vue&type=style&index=0&id=a475d5d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports